import { render, staticRenderFns } from "./CopyrightPanel.vue?vue&type=template&id=235aa645&scoped=true&"
import script from "./CopyrightPanel.vue?vue&type=script&lang=ts&"
export * from "./CopyrightPanel.vue?vue&type=script&lang=ts&"
import style0 from "./CopyrightPanel.vue?vue&type=style&index=0&id=235aa645&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235aa645",
  null
  
)

export default component.exports